import { render, staticRenderFns } from "./getProduct.vue?vue&type=template&id=1f1ee5db&scoped=true&"
import script from "./getProduct.vue?vue&type=script&lang=js&"
export * from "./getProduct.vue?vue&type=script&lang=js&"
import style0 from "./getProduct.vue?vue&type=style&index=0&id=1f1ee5db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ee5db",
  null
  
)

export default component.exports